export enum EcommerceProductStatus {
	DETAIL = "detail",
	VIEW = "view",
	CLICK = "click",
	ADD = "add",
	CHECKOUT = "checkout",
	REMOVE = "remove",
	ORDER = "order"
}
